
import {
  defineComponent,
  toRefs,
  computed,
  ref,
  watch,
  ComputedRef,
  onBeforeMount,
} from "vue";
import { useStore } from "vuex";
import { Information } from "../../../../domain/entities/information";
import TUIViewer from "../../components/application/TUIViewer.vue";
import SectionDivisor from "../landingpage/SectionDivisor.vue";
import { dispatchErrorBox } from "../mixins";

export default defineComponent({
  name: "Faq",
  components: { TUIViewer, SectionDivisor },
  props: {
    isVisible: { type: Boolean, default: true },
    isOpen: { type: Boolean, default: true },
  },
  setup(props, { emit }) {
    const { isVisible } = toRefs(props);
    const store = useStore();
    const openItems = ref<boolean[]>([]);
    const searchQuery = ref("");
    const loading = ref(true);

    const informations: ComputedRef<Information[]> = computed(() => {
      return store.getters["information_module/informationsLandingPage"];
    });

    const filteredInformations = computed(() => {
      if (!searchQuery.value) return informations.value;
      return informations.value.filter((item) =>
        item.question.toLowerCase().includes(searchQuery.value.toLowerCase())
      );
    });

    const toggleInfo = () => {
      emit("toggle-info");
    };

    watch(
      () => informations.value,
      (newVal) => {
        openItems.value = newVal.map((_, index) => index === 0);
      },
      { immediate: true }
    );

    const toggleItem = (index: number) => {
      const currentScrollPosition = window.scrollY;

      openItems.value = openItems.value.map((isOpen, i) =>
        i === index ? !isOpen : isOpen
      );

      requestAnimationFrame(() => {
        window.scrollTo(0, currentScrollPosition);
      });
    };

    const fetchInformations = async () => {
      if (!isVisible.value) return;

      try {
        await store.dispatch("information_module/listLandingPage");
        loading.value = false;
      } catch (e) {
        loading.value = false;
        await dispatchErrorBox("Ocorreu um erro ao carregar as informações.");
      }
    };

    watch(
      () => isVisible.value,
      async (newVal) => {
        if (newVal) {
          await fetchInformations();
        }
      }
    );

    onBeforeMount(async () => {
      await fetchInformations();
    });

    return {
      isVisible,
      informations,
      filteredInformations,
      openItems,
      toggleInfo,
      toggleItem,
      fetchInformations,
      searchQuery,
    };
  },
});
